import "../lib/_jquery.js"
import './shared/log-override'
import Rails from '@rails/ujs'
import("@rails/activestorage").then(a => a.start())
import('./shared/sjcl').then(value => window.sjcl = value)

import '@claviska/jquery-minicolors'
import '@claviska/jquery-minicolors/jquery.minicolors.css'
import 'bootstrap';
import "masonry-layout"
import './shared/detect_change'
import './shared/utils'

import './backend_vue.js'

import './backend/wysiwyg'
import './backend/sortable'
import "chartkick"
import "chart.js"

if (!window._rails_loaded) Rails.start();

// for collapsible sidebar in slide edit view
import {CollapsibleSidebar} from "./backend/collapsible_sidebar";
$(function() {
  $('.collapse-horizontal').each(function () {
    this.collapsibleSidebar = new CollapsibleSidebar(this);
  })
})

// When an input is set inside an element with the data-exclusive="xyz" prop set, all other inputs inside an element
// with data-exclusive="xyz" will be disabled, except the ones in the same element as the source
$(function () {
  $('[data-exclusive]').each(function () {
    let groupName = $(this).data('exclusive')
    let groupElement = $(this)
    $(this).find(':input').on('blur', function () {
      let inputs = $(`[data-exclusive=${groupName}]`).find(':input:not(button):not([type=hidden])')
      let groupInputs = groupElement.find(':input:not(button):not([type=hidden])')
      if (groupInputs.is(function() {return this.value.length > 0 })) {
        inputs.prop('disabled', true)
        groupElement.find(':input').prop('disabled', false)
        inputs.filter('[disabled]').val('')
      } else {
        inputs.prop('disabled', false)
      }
    })
  })
})

$(document).on('change', '.custom-file-input', function(){
  let $label = $(this).prev('.form-label')

  let originalLabel = $label.data('original-label')
  if( originalLabel === undefined ){
    originalLabel = $label.html()
    $label.data('original-label', originalLabel)
  }

  let file = this.files[0]
  if( file ){
    $label.html(file.name)
  } else {
    $label.html(originalLabel)
  }
})

// makes popovers work
$(function () {
  $('[data-bs-toggle="popover"]').popover()
})

// used in election config to select colors (attribute/_color.html.erb)
$(function(){
  $('.js-colorpicker').each((index, node) => {
    $(node).minicolors({
      theme: 'bootstrap',
      ...node.dataset
    })
  })
})

// used for preview images
$(function() {
  $('.js-preview-image').each(function(){
    let imageInput = $(this).find('.custom-file-input')[0];
    let fieldName = imageInput.getAttribute('name')
    let fieldValue = imageInput.dataset.imageUrl || "";
    if(!fieldValue.startsWith('http')) fieldValue = ""

    $(this).parent().prepend(`<input id="${fieldName}Hidden" value="" type="hidden" name="${fieldName.replace('[','[remove_')}" />`)
    $(this).append(`
              <a href="javascript:void(0)" id="${fieldName}Undo" class="btn btn-outline-secondary" style="display:none"><span class="fas fa-undo"></span> </a>
              <a href="javascript:void(0)" id="${fieldName}Remove" class="btn btn-danger disabled"><span class="fas fa-trash"></span> </a>
            `)
    let preview = document.getElementById(fieldName + 'Preview');
    if(preview === null) {
      preview = $(`<img style="display: none" src="${fieldValue}" class="img-fluid" id="${fieldName}Preview">`)[0]
      $(this).parent().append(preview)
    }
    if(fieldValue !== "") {
      preview.style.display = 'block';
    }
    let input = imageInput;
    let hidden = document.getElementById(fieldName + 'Hidden');
    let remove = document.getElementById(fieldName + 'Remove');
    let undo = document.getElementById(fieldName + 'Undo');

    remove.classList.toggle('disabled', fieldValue === "")
    input.onchange = function (ev) {
      const file = ev.target.files[0];
      preview.src = URL.createObjectURL(file);
      preview.style.display = 'block';
      remove.classList.remove('disabled');
    }
    remove.onclick = function () {
      preview.style.opacity = 0.5;
      hidden.value = '1';
      undo.style.display = 'block';
      remove.style.display = 'none';
    };

    undo.onclick = function () {
      preview.style.opacity = 1;
      hidden.value = '';
      undo.style.display = 'none';
      remove.style.display = 'block';
    };
  })
})

// select all checkboxes button
$(function(){
  let checkboxes = document.querySelectorAll('input[data-all="all"]')
  let allCheckboxbtn = $('#check_all')
  let allUncheckBtn = $('#uncheck_all')

  allUncheckBtn.on("click", function (e) {
    e.preventDefault()

    for (let i = 0; i < checkboxes.length; i++) {
      let item = checkboxes[i];
      item.checked = false
    }
  });


  allCheckboxbtn.on("click", function(e) {
    e.preventDefault()

    for (let i = 0; i < checkboxes.length; i++) {
      let item = checkboxes[i];
      item.checked = true
    }
  });

  function removeCheckedAll(event) {
    allCheckboxbtn.prop('checked', false)
  }
  Array.prototype.forEach.call(checkboxes, function(checkbox) {
    checkbox.addEventListener('click', removeCheckedAll)
  })
})

